module.exports = "/assets/sqsvg-12373a04e2c60ca97bd0b90c274a1684.svg";